import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserModel } from '@app/modules/user/model/user';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-private-header',
  templateUrl: './private-header.component.html',
  styleUrls: ['./private-header.component.sass', './private-header-nav.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivateHeaderComponent {
  @Input() user$: Observable<UserModel>;

  /** Sign out is a first-class header action — never buried in settings. */
  @Output() logoutEvent = new EventEmitter<void>();

  @Input() newNotificationCount$: Observable<number>;

  @Output() changeNotificationVisibleEvent = new EventEmitter<boolean>();

  @Output() changeUserSidebarVisibleEvent = new EventEmitter<boolean>();

  constructor(private readonly router: Router) {}

  /** The three things a person needs from their avatar, one click away. */
  public get accountMenu() {
    return [
      // A page, not the slide-over: the drawer's mask hides whatever the
      // person was looking at, which is the wrong shape for a screen you
      // read and edit. "Change password" still opens the drawer.
      { label: 'My profile', command: () => this.router.navigate(['/office/profile']) },
      { label: 'Change password', command: () => this.changeUserSidebarVisibleEvent.emit(true) },
      { label: 'Security & two-factor', command: () => this.router.navigate(['/office/security/mfa']) },
      { label: 'Sign out', command: () => this.logoutEvent.emit() },
    ];
  }
}
